export default __webpack_public_path__ + "static/media/our-services-section-three-arrow-left.8c99ce2a.svg";